import UsuarioService from 'services/UsuarioService'
import { Usuario } from './types'

class MenuContaManager {
  atualizarPreferenciasUsuario = async ({ tema, idioma }: Usuario) => {
    const body = {
      tema,
      backGround: tema,
      idioma: idioma?.toUpperCase()
    }
    try {
      await UsuarioService.patchUsuarios(body)
      return body
    } catch (error) {
      return { tema: 'L', idioma: 'PT' }
    }
  }
}

export default new MenuContaManager()
